(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const triggerSelector = '[data-adwoa-bag], .adwoa-mobile-bag, [data-bag]';

    const getDrawer = () => document.querySelector('cart-drawer');

    const openDrawer = (trigger) => {
      const drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      if (typeof drawer.open === 'function') drawer.open(trigger);
    };

    const closeDrawer = () => {
      const drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      if (typeof drawer.close === 'function') drawer.close();
    };

    const syncBagCount = () => {
      const countNode = document.querySelector('.drawer__heading[data-cart-count]');
      if (!countNode) return;
      const count = countNode.dataset.cartCount || '0';
      document.querySelectorAll(triggerSelector).forEach((trigger) => {
        trigger.textContent = `BAG (${count})`;
      });
    };

    document.addEventListener('click', (event) => {
      const closeTrigger = event.target.closest('[data-adwoa-cart-close], #CartDrawer-Overlay');
      if (closeTrigger) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const trigger = event.target.closest(triggerSelector);
      if (!trigger) return;
      event.preventDefault();
      openDrawer(trigger);
    });

    const observeDrawer = () => {
      const drawer = getDrawer();
      if (!drawer) return;
      syncBagCount();
      new MutationObserver(syncBagCount).observe(drawer, {
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeDrawer, { once: true });
    } else {
      observeDrawer();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
